import React, { useState, useEffect } from "react";
import axios from "axios";
import ProductCard from "./ProductCard";
import "./css/products.css";
import { ReactComponent as SliderIcon } from "../../icons/sliders.svg";
import { useNavigate } from "react-router-dom";
export default function Main() {
  const navigate = useNavigate()
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [menuVisible, setMenuVisible] = useState(false); 
  const token = localStorage.getItem("access_token");
  const [category, setCategory] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get("https://monkeprogrammer01.pythonanywhere.com/products/category/");
        console.log(response.data);
        const { products, categories } = response.data;
        setProducts(products);
        setCategory(categories);
        console.log(products);
      } catch (err) {
        setError(err);
        console.error("Error fetching products:", err);
      } finally {
        setLoading(false); 
      }
    };
    fetchProducts();
  }, []);

  if (loading) {
    return <p>Loading products...</p>;
  }

  if (error) {
    return <p>Error loading products: {error.message}</p>;
  }

  const filteredProducts = (products).filter((product) => {
    const matchesSearch = product.product_name.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory = selectedCategories.length === 0 || selectedCategories.includes(product.product_category);
    return matchesCategory && matchesSearch;
  });

  const handleCategoryClick = (e, category) => {
    e.preventDefault();
    setSelectedCategories((prevSelectedCategories) => {
      if (prevSelectedCategories.includes(category)) {
        return prevSelectedCategories.filter((cat) => cat !== category);
      } else {
        return [...prevSelectedCategories, category];
      }
    });
  };

  const handleResetCategories = (e) => {
    e.preventDefault();
    setSelectedCategories([]); 
  };

  return (
    <>
      <div className="search-container">
        <input
          type="text"
          placeholder="Поиск товаров..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
        <div className="slider-icon">
          <button
            className="dropdown-button"
            onClick={() => setMenuVisible(!menuVisible)}
          >
            <SliderIcon />
          </button>
          {menuVisible && (
            <div className={`dropdown-content ${menuVisible ? "visible" : ""}`}>
              {category.map((item) => (
                <a 
                  href="#" 
                  key={item.id} 
                  onClick={(e) => handleCategoryClick(e, item.id)} 
                  style={{
                    backgroundColor: selectedCategories.includes(item.id) ? "#ddd" : "transparent",
                  }}
                >
                  {item.name}
                </a>
              ))}
                <a
                href="#"
                onClick={(e) => { 
                    e.preventDefault(); 
                    handleResetCategories(e);  // Передаем e в handleResetCategories
                    setMenuVisible(false); 
                }}
                >
                Все категории
                </a>
            </div>
          )}
        </div>
      </div>

      {filteredProducts.length > 0 ? (
        filteredProducts.map((product) =>
          product.quantity === 0 ? null : (
            <ProductCard
              key={product.id}
              product={product}
              showButton={true}
            />
          )
        )
      ) : (
        <p style={{ textAlign: "center", color: "#7f8c8d" }}>
          Товары не найдены
        </p>
      )}
    </>
  );
}
